import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LinkButton, SecondaryButton } from "../../../../common/Buttons";
import AttorneyDetails from "./AttorneyDetails";
import ReplacementAttorney from "./ReplacementAttorney";

const Attorney = ({ next, pre, setButtonDisabled, buttonDisabled }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(1);
  const nextTab = () => {
    setCurrentTab(2);
  };
  const preTab = () => {
    setCurrentTab(1);
  };
  const tabMapper = {
    1: (
      <AttorneyDetails
        next={next} 
        pre={pre}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    // 2: (
    //   <ReplacementAttorney
    //     next={next}
    //     pre={preTab}
    //     setButtonDisabled={setButtonDisabled}
    //   />
    // ),
  };
  const renderTab = () => {
    return tabMapper[currentTab];
  };

  return (
    <>
      {renderTab()}
      <div
        style={{
          minWidth: "310px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="#E8D7E5"
          borderRadius="14px"
          width="180px"
          marginLeft="20px"
          border="none"
          hoverBgColor="color.magentaLight1"
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
          form="form_submit"
          type="submit"
          disabled={buttonDisabled}
        />
        <LinkButton
          title={t("skip-for-now")}
          bgColor="color.transparent"
          borderRadius="14px"
          fontSize="0.8rem"
          width="100px"
          marginLeft="10px"
          padding="0"
          border="none"
          click={() => {
           next();
          }}
          textTransform="initial"
        />
      </div>
    </>
  );
};

export default Attorney;
